<template>
  <div>
    <basic-container>
      <div style="height: 20px"></div>
      <el-form :inline="true" ref="form" :model="form">
        <el-row>
          <el-col span="5">
            <el-form-item
              label="公寓名称"
              prop="roomName"
              :rules="[{ required: true, message: '请选择公寓', trigger: 'blur' }]"
            >
              <el-select
                v-model="form.roomName"
                filterable
                clearable
                collapse-tags
                style="margin-left: 20px"
                placeholder="请选择公寓小区"
              >
                <el-option
                  v-for="item in allPropertyList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.title"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="5">
            <el-form-item
              label="账单周期"
              prop="billcycleNo"
              :rules="[{ required: true, message: '请选择账单周期', trigger: 'blur' }]"
            >
              <el-date-picker
                v-model="form.billcycleNo"
                filterable
                type="month"
                :clearable="false"
                placeholder="请选择账单周期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="5">
            <el-form-item label="是否收款" prop="payStatus">
              <el-select
                v-model="form.payStatus"
                filterable
                clearable
                collapse-tags
                style="margin-left: 20px"
                placeholder="请选择是否收款"
              >
                <el-option
                  v-for="item in payStatusList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="5">
            <el-form-item label="收款方式" prop="payStatus">
              <el-select
                v-model="form.payType"
                filterable
                clearable
                collapse-tags
                style="margin-left: 20px"
                placeholder="请选择收款方式"
              >
                <el-option
                  v-for="item in payTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="3">
            <el-form-item>
              <el-button type="primary" @click="onSubmit">立即查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <WebReport ref="WebReport" :url="url" :params="params" :roomName="roomName" :name="name" />
    </basic-container>
  </div>
</template>

<script>
import WebReport from '@/components/web-report';
import { getDepartmentCommunityTree } from '../../../api/v4ward/property/baseproperty';
import { getDictionaryWithIntKey } from '../../../api/common';
import urlSettings from '@/config/url-settings.js';
import { getCommunityGroupList } from '../../../api/common';
    import _ from 'lodash';
export default {
  components: {
    WebReport,
  },
  data() {
    return {
      communityGroupList:[],
      url: '',
      form: {
        communityGroup:'',
        roomName: [],
        billcycleNo: '',
        payStatus: '',
        payType: '',
      },
      allPropertyList: [],
      bankCutPaymentList: [],
      payTypeList: [],
      payStatusList: [],
      oldOptions: [],
      params: {
        reportlet: urlSettings.VUE_APP_ENVIRONMENT + '/departmentBillDetails.cpt',
      },
      dic: [],
    };
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.params.roomName = this.form.roomName;
          this.params.billcycleNo = this.dayjs(this.form.billcycleNo).format('YYYYMM');
          this.params.payStatus = this.form.payStatus;
          this.params.payType = this.form.payType;
          setTimeout(() => {
            this.$refs.WebReport.regroupUrl();
          }, 0);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    initPropertyList() {
      getDepartmentCommunityTree({}).then((data) => {
        this.allPropertyList = data.data;

        var reportUrl = urlSettings.BASE_REPORT_URL;
        this.url = reportUrl.split('?')[0];
        cb(data.data);
        // this.url =
        //   'http://localhost:8075/WebReport/ReportServer?reportlet=pmsone%2FdepartmentBillDetails.cpt';
        setTimeout(() => {
          this.$refs.WebReport.regroupUrl();
        }, 0);
      });

      getDictionaryWithIntKey('payYesOrNo').then((data) => {
        this.payStatusList = data.data;
      });
      getDictionaryWithIntKey('pay_way').then((data) => {
        this.payTypeList = data.data;
      });
    },
  },


  created() {
    // this.initPropertyList();
    let this_ = this;
      getCommunityGroupList().then((res)=>{
        this.communityGroupList = res.data;
        this.form.communityGroup = res.data[0].dictKey;
          this.initPropertyList((data)=>{
              // this.form.communityId = data[0].id;
              this.form = _.cloneDeep(this_.form);
              // this.onLoad();
          });
      });
  },
};
</script>

<style scoped></style>
